import React from 'react'
import { Container, Typography } from '@mui/material'
import FeaturesGrid from '../modules/FeaturesGrid'

const AppFeatures = (props) => {
  return (
    <Container>
      <Typography component="h2" variant="h2" fontSize={40} fontWeight={600}>
        Features
      </Typography>
      <FeaturesGrid isPro={false} />
    </Container>
  )
}

export default AppFeatures